import Vue from 'vue'
import store from '../store'
import { user as userStore } from '../store/modules/user'

const user = {
  check() {
    return store.state.token
  },
  pro() {
    return store.state.access && !!store.state.token
  },
  regular() {
    return !store.state.access && !!store.state.token
  }
}

export default {
  guest(to, from, next) {
    next(!user.check() ? true : {
      name: 'profile'
    })
  },
  auth(to, from, next) {
    next(user.check() ? true : {
      name: 'login'
    })
  },
  pro(to, from, next) {
    next(user.pro() ? true : {
      name: 'regular'
    })
  },
  regular(to, from, next) {
    next(user.regular() ? true : {
      name: 'home'
    })
  }
}
